import * as React from 'react';
import { Button } from 'antd';
import { useState } from 'react';
import { filterAndSortKeyFigureData } from 'utils/keyfigures';
import t from 'utils/translations';
import { KeyFigureData } from 'components/context/types';
import { KeyFigureGraphBody } from 'components/common/KeyFigureGraph/KeyFigureGraphBody';
import {
    KeyFigureInfo,
    keyFigureInfoArray,
    KeyFigureSelector
} from 'components/common/KeyFigureGraph/KeyFigureSelector';
import styled from 'styled-components';
import { Card, CardBody, CardHeader, CardTitle } from 'components/common/Card';
import CompareGraphModal from 'components/common/KeyFigureGraph/CompareGraphModal';

export const GraphCardHeader = styled(CardHeader)`
    align-items: center;
    display: flex;
    justify-content: space-between;
`;

export const GraphSelectors = styled.div``;

export interface SecondaryCompanyInfo {
    name: string;
    businessId: string;
}

interface Props {
    showMonths: boolean;
    canCompare: boolean;
    isAggregateData: boolean;
    isLoading: boolean;
    keyFigureData?: KeyFigureData;
    title: React.ReactElement;
    sampleLowerLimit?: number;
}

export const CompanyKeyFigureGraphs = ({
    showMonths,
    canCompare,
    isAggregateData,
    isLoading,
    keyFigureData,
    title,
    sampleLowerLimit
}: Props) => {
    const [isCompareModalVisible, setIsCompareModalVisible] = useState(false);
    const [secondaryKeyFigureData, setSecondaryKeyFigureData] = useState<
        KeyFigureData | undefined
    >(undefined);

    const [selectedKeyFigureInfo, setSelectedKeyFigureInfo] = useState<
        KeyFigureInfo
    >(keyFigureInfoArray[0]);

    keyFigureData = keyFigureData
        ? keyFigureData
        : {
              seriesName: '',
              keyFigures: []
          };
    const isDataAvailable = keyFigureData.keyFigures.length > 0;

    const renderCompareButton = () => {
        return secondaryKeyFigureData ? (
            <Button
                size="small"
                onClick={() => setSecondaryKeyFigureData(undefined)}
            >
                {t('EMPTY')}
            </Button>
        ) : (
            <Button
                disabled={!isDataAvailable}
                size="small"
                onClick={() => setIsCompareModalVisible(!isCompareModalVisible)}
            >
                {t('COMPARE')}
            </Button>
        );
    };

    return (
        <Card>
            <GraphCardHeader>
                <CardTitle>{title}</CardTitle>
                <GraphSelectors>
                    <KeyFigureSelector
                        disabled={!isDataAvailable}
                        setKeyFigureInfo={setSelectedKeyFigureInfo}
                    />
                    {canCompare && renderCompareButton()}
                </GraphSelectors>
            </GraphCardHeader>
            <CardBody>
                <KeyFigureGraphBody
                    isAggregateData={isAggregateData}
                    showMonths={showMonths}
                    isLoading={isLoading}
                    keyFigureSuffix={selectedKeyFigureInfo.suffix}
                    primaryDataSet={
                        keyFigureData
                            ? filterAndSortKeyFigureData(
                                  keyFigureData,
                                  sampleLowerLimit
                              )
                            : {
                                  seriesName: '',
                                  keyFigures: []
                              }
                    }
                    secondaryDataSets={
                        secondaryKeyFigureData
                            ? [
                                  filterAndSortKeyFigureData(
                                      secondaryKeyFigureData,
                                      sampleLowerLimit
                                  )
                              ]
                            : []
                    }
                    selectedKeyFigureField={selectedKeyFigureInfo.dataFieldName}
                    sampleSizeField={selectedKeyFigureInfo.sizeFieldName}
                    title={t(selectedKeyFigureInfo.explanation)}
                    yAxisLabel={t(selectedKeyFigureInfo.key)}
                />
            </CardBody>
            {canCompare && (
                <CompareGraphModal
                    closeModal={() => setIsCompareModalVisible(false)}
                    setSecondaryDataSet={setSecondaryKeyFigureData}
                    visible={isCompareModalVisible}
                />
            )}
        </Card>
    );
};
